<template>
  <SubsectionNavBottom class="section--top" parent="Why Digital" :sidebar="sidebar" :subSections="subSections">
    <router-view></router-view>
  </SubsectionNavBottom>
</template>

<script>
import { defaultMixins, filters } from '@/common/mixins';

import SubsectionNavBottom from '@/layout/SubsectionNavBottom.vue';

export default {
  name: 'WhyDigital',
  mixins: [defaultMixins, filters],
  props: {
    sidebar: Boolean,
  },
  components: {
    SubsectionNavBottom,
  },
  computed: {
    subSections() {
      const subMenuOptions = [
        {
          label: this.$i18n.t('why-digital.submenu.digital-value'),
          shareLabel: 'Digital Value Proposition',
          url: '',
        },
        {
          label: this.$i18n.t('why-digital.submenu.customers'),
          shareLabel: 'Customers',
          url: 'customers',
        },
      ];
      if (this.$store.state.currentPrinter === 3) {
        subMenuOptions.push({
          label: this.$i18n.t('why-digital.submenu.manufacturing-benefits'),
          shareLabel: 'Manufacturing Benefits',
          url: 'manufacturing-benefits',
        });
      }
      return subMenuOptions;
    },
  },
};
</script>
